module.exports = __webpack_public_path__ + "ec87e04bcde8bd55eb178b1b9b5a910c.svg";